<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;">
                <v-toolbar flat height="45px">
                    <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details style="margin-bottom:15px;"></v-text-field>
                    <v-spacer></v-spacer>
                    <b>{{cutOffPeriod}}</b>                    
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="timeoff_details_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view timesheet for this period">
                            <td>
                                <v-chip>
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>{{ props.item.transDate | moment("YYYY-MM-DD") }}</td>
                            <td>{{ props.item.leaveName }}</td>
                            <td>{{ props.item.hours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout>  
</template>

<script>

import timeOffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'TeamTimeOff',
    metaInfo: {
        title: 'Team TimeOff',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Team TimeOff' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    props: ['teamId', 'pageKey'],
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            headers: [
                {text: 'Employee',align: 'left',value: 'lastName', width:'15%', sortable:true},
                {text: 'Date',align: 'left',value: 'transDate', width:'10%', sortable:true},
                {text: 'Leave Type',align: 'left',value: 'leaveName', width:'20%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'10%',sortable:true},
            ],
            loading_download: false,
            cutoff_details: null,
            timeoff_details: [],
        }
    },
    methods: {  
        async downloadToExcel() {},
        viewDetails(data) {
            this.$router.push(`/myteam/timeoff/details/${data.timeOffId}`)
        }, 
        async getTimeOff() {
            try {
                this.loading = true
                const response = await timeOffApi.getByCutoffByTeam(this.selectedCutOffId, this.pageKey, this.teamId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.timeoff_details = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Time Offs`
        })

        this.getTimeOff()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details!=null)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        timeoff_details_filtered() {
            var temp = this.timeoff_details

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( 
                            item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase())
                        )
                })
            }
            return temp
        },
        helpPageId() {
            return 'timeoff-review-team'
        },
        frozenPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        }
    }
}
</script>